import(/* webpackMode: "eager" */ "/Users/surajsajjan/Desktop/rpcollege/src/app/not-found.tsx");
